import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";

import { Navbar, Footer } from "../hrcomponents";
import configData from "../config.json";
import { empCategory, empType } from "../utils/datalist";

const AddEmployee = () => {

  // =========================
  // Redirect if no branch
  // =========================

  useEffect(() => {
    if (!localStorage.getItem("branchID")) {
      window.location.replace("/hris");
    }
  }, []);

  // =========================
  // States
  // =========================

  const [loading, setLoading] = useState(false);

  const [deptList, setDeptList] = useState([]);
  const [desigtList, setDesigtList] = useState([]);

  const [empData, setEmpData] = useState({
    branchID: localStorage.getItem("branchID") || "",
    empCode: "",
    fp_code: "",
    empName: "",
    empStatus: "A",
    empCategory: "",
    empType: "",
    dateOfJoin: "",
    deptID: "",
    desigID: ""
  });

  // =========================
  // Load Initial Data
  // =========================

  useEffect(() => {

    const loadData = async () => {

      try {

        const [deptRes, desigRes] = await Promise.all([

          axios.get(`${configData.SERVER_URL}/deptData/${localStorage.getItem("branchID")}`),

          axios.get(`${configData.SERVER_URL}/designations`)

        ]);

        setDeptList(deptRes.data || []);
        setDesigtList(desigRes.data || []);

      } catch (err) {

        console.error(err);
        alert("Failed to load data");

      }
    };

    loadData();

  }, []);

  // =========================
  // Input Change
  // =========================

  const handleInput = (e) => {

    const { name, value } = e.target;

    setEmpData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // =========================
  // Select Change
  // =========================

  const handleSelectChange = (selectedOption, fieldName) => {

    setEmpData(prev => ({
      ...prev,
      [fieldName]: selectedOption ? selectedOption.value : ""
    }));
  };

  // =========================
  // Select Options
  // =========================

  const deptOptions = deptList.map(d => ({
    value: d.id,
    label: `${d.deptName}`
  }));

  const desigOptions = desigtList.map(d => ({
    value: d.id,
    label: `${d.desigName}`
  }));

  // =========================
  // Submit
  // =========================

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      setLoading(true);

      const res = await axios.post(
        `${configData.SERVER_URL}/empDataInsert`,
        empData
      );

      if (res.status === 200) {

        alert(res.data.message || "Saved Successfully");

        // Optional Reset
        setEmpData(prev => ({
          ...prev,
          empCode: "",
          fp_code: "",
          empName: "",
          empCategory: "",
          empType: "",
          dateOfJoin: "",
          deptID: "",
          desigID: ""
        }));
      }

    } catch (error) {

      console.error(error);

      alert(
        error?.response?.data?.message ||
        "System Error"
      );

    } finally {

      setLoading(false);
    }
  };

  // =========================
  // Render
  // =========================

  return (
    <div className="container" >

      <div className="card shadow border-0" 
                style={{ background: "#fff", borderRadius: "18px", overflow: "hidden", }}>
            {/* Header */}
          <div className="card-header d-flex justify-content-between align-items-center"
                style={{
                background: "linear-gradient(135deg, #0d6efd, #0dcaf0)",
                color: "#fff",
                padding: "18px 25px",
                border: "none",
                }} >
                <div>
                    <h3 className="mb-0 fw-bold">Employee Entry</h3>
                    <small>Add New Employee Data</small>
                </div>
          </div>

        <div className="card-body bg-light">

          <form onSubmit={handleSubmit}>
            <div className="row g-3">
                {/* Employee Code */}
              <div className="col-lg-3 col-md-4">
                <label className="form-label">
                  Employee Code
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="empCode"
                  value={empData.empCode}
                  onChange={handleInput}
                />
              </div>

              {/* Finger Print */}
              <div className="col-lg-3 col-md-4">
                <label className="form-label">
                  Fingerprint / Face ID
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="fp_code"
                  value={empData.fp_code}
                  onChange={handleInput}
                />
              </div>
            </div>

            <div className="row g-3">

              {/* Employee Name */}
              <div className="col-lg-6 col-md-8">
                <label className="form-label">
                  Employee Name
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="empName"
                  value={empData.empName}
                  onChange={handleInput}
                />
              </div>
            </div>

            <div className="row g-3">
              {/* Status */}
              <div className="col-lg-3 col-md-4">
                <label className="form-label">
                  Employee Status
                </label>

                <select
                  className="form-select"
                  name="empStatus"
                  value={empData.empStatus}
                  onChange={handleInput}
                >
                  <option value="">---</option>
                  <option value="A">Active</option>
                  <option value="I">Inactive</option>
                </select>
              </div>

              {/* Category */}
              <div className="col-lg-3 col-md-4">
                <label className="form-label">
                  Employee Category
                </label>

                <select
                  className="form-select"
                  name="empCategory"
                  value={empData.empCategory}
                  onChange={handleInput}
                >
                  <option value="">---</option>

                  {empCategory.map(category => (
                    <option
                      key={category.code}
                      value={category.code}
                    >
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="row g-3">

              {/* Employee Type */}
              <div className="col-lg-3 col-md-4">
                <label className="form-label">
                  Employee Type
                </label>

                <select
                  className="form-select"
                  name="empType"
                  value={empData.empType}
                  onChange={handleInput}
                >
                  <option value="">---</option>

                  {empType.map(type => (
                    <option
                      key={type.code}
                      value={type.code}
                    >
                      {type.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Date of Join */}
              <div className="col-lg-3 col-md-4">
                <label className="form-label">
                  Date of Join
                </label>

                <input
                  type="date"
                  className="form-control"
                  name="dateOfJoin"
                  value={empData.dateOfJoin}
                  onChange={handleInput}
                />
              </div>
            </div>

            <div className="row g-3">
              {/* Department */}
              <div className="col-lg-4 col-md-6">
                <label className="form-label">
                  Department
                </label>

                <Select
                  options={deptOptions}
                  isSearchable
                  placeholder="Select Department"

                  value={deptOptions.find(
                    option =>
                      option.value === empData.deptID
                  )}

                  onChange={(option) =>
                    handleSelectChange(option, "deptID")
                  }
                />
              </div>

              {/* Designation */}
              <div className="col-lg-4 col-md-6">
                <label className="form-label">
                  Designation
                </label>

                <Select
                  options={desigOptions}
                  isSearchable
                  placeholder="Select Designation"

                  value={desigOptions.find(
                    option =>
                      option.value === empData.desigID
                  )}

                  onChange={(option) =>
                    handleSelectChange(option, "desigID")
                  }
                />
              </div>

              {/* Submit */}
              <div className="col-12 mt-3">

                <button
                  type="submit"
                  className="btn btn-info"
                  disabled={loading}
                >
                  {
                    loading
                    ? "Saving..."
                    : "Save Employee"
                  }
                </button>

              </div>

            </div>

          </form>

        </div>

      </div>

    </div>
  );
};

export default AddEmployee;